import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { AlmanacLogo } from '../components/AlmanacLogo';

export function LoginPage() {
  const { status, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'authenticated') navigate('/', { replace: true });
  }, [status, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-xl border border-border bg-card p-8 text-card-foreground shadow-sm">
        <AlmanacLogo />
        <p className="mt-2 text-sm text-muted-foreground">
          Your Langston assistant, on any device.
        </p>
        <button
          type="button"
          onClick={login}
          className="mt-6 w-full rounded-lg bg-primary px-4 py-2 font-medium text-primary-foreground hover:bg-primary/90"
        >
          Sign in with Langston
        </button>
      </div>
    </div>
  );
}
